import { encode } from 'uqr'

/** Tiny QR as SVG (for magic links / invites). */
export function QrSvg({
  value,
  size = 200,
  className,
}: {
  value: string
  size?: number
  className?: string
}) {
  const qr = encode(value, { ecc: 'M', border: 2 })
  const modules = qr.size
  const cell = size / modules
  const rects: React.ReactNode[] = []
  for (let y = 0; y < modules; y++) {
    for (let x = 0; x < modules; x++) {
      if (qr.data[y]![x]) {
        rects.push(
          <rect
            key={`${x}-${y}`}
            x={x * cell}
            y={y * cell}
            width={cell}
            height={cell}
            fill="currentColor"
          />
        )
      }
    }
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className={className}
      role="img"
      aria-label="QR-code"
    >
      <rect width={size} height={size} fill="white" />
      <g className="text-green-950">{rects}</g>
    </svg>
  )
}
